// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"8855d992","93":"56923370","100":"ca1477d9","130":"19cfba9e","247":"c2e07ec8","284":"7236a9cf","350":"7707f45c","478":"10a3d15e","565":"85f47cdf","584":"5f20588d","677":"0607e364","715":"d0a3167d","754":"cdf547a1","815":"fd4a9948"}[chunkId] + ".chunk.js";
};